export default __webpack_public_path__ + "static/media/2019-toyota-corolla-dashboard-2000x1125.6ea41ec3.jpg";